import { useTranslation } from 'react-i18next';
import { useUserContext } from '../context/UserContext'

const useDefaultAttachmentsFormSchema = (props) => {
    const { t } = useTranslation();
    const { token } = useUserContext()

    let uploadSchema = {
        id: "uploadSchema",
        elements: [
            {
                type: "grid",
                direction: 'row',
                spacing: 2,
                elements: [
                    {

                        type: "text",
                        name: 'name',
                        label: t('name'),
                        item: {
                            xs: 12
                        },
                        validators: [
                            {
                                name: 'required',
                                config: {
                                    msg: t('name_is_required')
                                }
                            },
                        ]
                    },
                    {

                        type: "upload",
                        name: 'files',
                        label: t('files'),
                        item: {
                            xs: 12
                        },
                        config: {
                            url: window.BASEURL + "api/storage/forms/upload-file",
                            token
                        }
                    },
                    {
                        type: 'grid'
                    }
                ]
            }

        ]
    }



    return {
        uploadSchema,
    }

}

export default useDefaultAttachmentsFormSchema;
